export default "__VITE_ASSET__BcDVWL7o__"